import { render, staticRenderFns } from "./ResellerAcceptForm.vue?vue&type=template&id=5768ba5c&"
import script from "./ResellerAcceptForm.vue?vue&type=script&lang=js&"
export * from "./ResellerAcceptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports